/**
 * Vocabulaire fiscal du marché de l'art.
 *
 * Quatre régimes suffisent aux factures d'une galerie française :
 * le taux normal, le taux réduit de l'importation et de la première vente par
 * l'artiste, la TVA sur la marge des biens d'occasion, et l'exonération
 * (exportation, livraison intracommunautaire).
 */
import { z } from 'zod';
import { POINTS_DE_BASE } from '../model/commun.js';
/** Régimes de TVA applicables à une ligne de facture. */
export const REGIMES_TVA = ['normal', 'reduit_5_5', 'marge', 'exonere'];
export const regimeTvaSchema = z.enum(REGIMES_TVA);
/** Taux de TVA, en points de base (10 000 = 100 %). */
export const TAUX_NORMAL = 2_000;
export const TAUX_REDUIT = 550;
/**
 * Catégories de TVA de la norme EN 16931 (BT-118), nécessaires au XML
 * Factur-X (7.6).
 *
 * - `S` : taux standard (normal et réduit) ;
 * - `E` : exonéré, avec mention du motif — c'est aussi la catégorie retenue
 *   pour la TVA sur la marge, qui n'apparaît pas sur la facture.
 */
export const CATEGORIES_TVA = ['S', 'E', 'Z', 'AE', 'K', 'G', 'O'];
export const categorieTvaSchema = z.enum(CATEGORIES_TVA);
/** Ce que chaque régime implique au calcul et à l'impression. */
export const DESCRIPTION_REGIMES = {
    normal: { taux: TAUX_NORMAL, categorie: 'S', tvaAffichee: true, prixTtc: false },
    reduit_5_5: { taux: TAUX_REDUIT, categorie: 'S', tvaAffichee: true, prixTtc: false },
    marge: { taux: TAUX_NORMAL, categorie: 'E', tvaAffichee: false, prixTtc: true },
    exonere: { taux: 0, categorie: 'E', tvaAffichee: true, prixTtc: false },
};
/** Le taux d'un régime, en points de base. */
export function tauxDuRegime(regime) {
    return DESCRIPTION_REGIMES[regime].taux;
}
/** Le taux d'un régime, en pourcentage (20, 5.5, 0). */
export function pourcentageDuRegime(regime) {
    return (tauxDuRegime(regime) * 100) / POINTS_DE_BASE;
}
//# sourceMappingURL=regimes.js.map